import { Component } from '@angular/core';

@Component({
  selector: 'app-selectable-list-content',
  templateUrl: './selectable-list-content.component.html',
  styleUrls: ['./selectable-list-content.component.scss']
})
export class SelectableListContentComponent {

}
